export const LEADERBOARD_LOADED = 'LEADERBOARD_LOADED';
export const DASHBOARD_LOADING = 'DASHBOARD_LOADING';
export const SET_TEAM = 'SET_TEAM';
export const SET_DOWNLINE = 'SET_DOWNLINE';
export const SET_DASHBOARD_COLLECTION = 'SET_DASHBOARD_COLLECTION';
export const HOME_WHATS_HAPPENING = 'HOME_WHATS_HAPPENING';

export const setDashboardCollection = (collection, array) => {
    const payload = { collection, array };
    return {
        type: SET_DASHBOARD_COLLECTION,
        payload,
    };
};

export const setTeam = payload => {
    return {
        type: SET_TEAM,
        payload: payload,
    };
};

export const setDownline = payload => {
    return {
        type: SET_DOWNLINE,
        payload: payload,
    };
};

export const dashboardLoading = payload => {
    return {
        type: DASHBOARD_LOADING,
        payload: payload,
    };
};

export const setHomeWhatsHappening = payload => {
    return {
        type: HOME_WHATS_HAPPENING,
        payload,
    };
};
